module.exports = __webpack_public_path__ + "img/lead-switcher.bfa06ee0.svg";